<div class="forest-image-container">
  <img src="assets/img/forest-service-logo.svg" alt="Forest Service" />
  <div class="help-title">
    <h1>Help Center</h1>
    <span>We're here to help. Search below, or select a tile to get started!</span>
  </div>
</div>

<div class="help-search-banner">
  <ciao-help-search
    layout="page"
    inputId="help-center-search"
    placeholder="Search How To Guides and FAQs"
  />
</div>

<div class="cards-container">
  <div class="flip-card">
    <div class="flip-card-inner">
      <div class="flip-card-front">
        <img
          class="icon"
          src="assets/img/icons/help/multitool.svg"
          alt="Multi-Tool"
        />
        <h3>"How To" Guides</h3>
      </div>
      <div class="flip-card-back">
        <h3>How To Guides</h3>
        <p>Access KBAs, training videos and User Guides</p>
        <a [routerLink]="['/help/info/how-to']">Visit How To Guides</a>
      </div>
    </div>
  </div>

  <div class="flip-card">
    <div class="flip-card-inner">
      <div class="flip-card-front">
        <img
          class="icon"
          src="assets/img/icons/help/clipboard.svg"
          alt="Clipboard"
        />
        <h3>Frequently Asked Questions</h3>
      </div>
      <div class="flip-card-back">
        <h3>Frequently Asked Questions</h3>
        <p>Common questions about using CIAO</p>
        <a [routerLink]="['/help/info/faq']">View FAQs</a>
      </div>
    </div>
  </div>

  <div class="flip-card">
    <div class="flip-card-inner">
      <div class="flip-card-front">
        <img
          class="icon"
          src="assets/img/icons/help/fieldgoer.svg"
          alt="Field Goer"
        />
        <h3>Admin</h3>
      </div>
      <div class="flip-card-back">
        <h3>Admin</h3>
        <p>Learn about Admin-related tasks and Roles & Permissions</p>
        <a [routerLink]="['/help/info/admin']">Visit Admin Guides</a>
      </div>
    </div>
  </div>

  <div class="flip-card">
    <div class="flip-card-inner">
      <div class="flip-card-front">
        <img
          class="icon"
          src="assets/img/icons/help/compass.svg"
          alt="Compass"
        />
        <h3>Getting Started Guide</h3>
      </div>
      <div class="flip-card-back">
        <h3>Getting Started Guide</h3>
        <p>Download our new guide for comprehensive look at how to use CIAO</p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="/assets/help/pdfs/Getting Started Guide - CIAO v2.5.pdf"
        >
          View Getting Started Guide
        </a>
      </div>
    </div>
  </div>

  <!-- <div class="flex-wrap-placeholder"></div>
  <div class="flex-wrap-placeholder"></div> -->
</div>

<div class="promo-row">
  <div class="promo-card flip-card-vertical">
    <div class="promo-card-inner">
      <div class="promo-card-front">
        <img
          class="promo-icon"
          src="assets/img/icons/help/shield.svg"
          alt="Shield"
        />
        <div class="promo-text">
          <img class="promo-new-badge" src="assets/img/icons/help/new-badge-red.svg" alt="NEW" />
          <h3>Check out what's new with CIAO user roles</h3>
          <p>See what's changing and what it means for your account</p>
        </div>
      </div>
      <div class="promo-card-back">
        <h3>Roles &amp; Permissions</h3>
        <p>Learn how changes may affect what you can access. Plus, new Guest user role.</p>
        <a [routerLink]="['/help/info/admin/roles-permissions']">View Roles &amp; Permissions</a>
      </div>
    </div>
  </div>
</div>
